import Vue, { ComponentOptions } from 'vue';
import axios, { AxiosInstance } from 'axios';
import VueAxios from 'vue-axios'
import App from './App.vue';
import router from './router';
import CoreuiVue from '@coreui/vue';
import { iconsSet as icons } from './assets/icons/icons.js';
import { PARAMS } from '../params';
import AuthService from './lib/auth/auth.service';
import { DataService } from '@/lib/data/services';

const $axios: AxiosInstance = axios.create();
$axios.defaults.baseURL = PARAMS.backend_url;

Vue.use(VueAxios, $axios)
Vue.config.performance = true;
Vue.use(CoreuiVue);

const $authService = new AuthService($axios);
Vue.prototype.$authService = $authService
Vue.prototype.$dataService = new DataService($axios, $authService);

declare module 'vue/types/options' {
  interface ComponentOptions<V extends Vue> {
    icons?: any;
  }
}

new Vue({
  el: '#app',
  router,
  icons,
  template: '<App/>',
  components: {
    App,
  },
});
